import { timelineSteps } from "@/mocks/evidence";

export default function TimelineCheck() {
  return (
    <section id="timeline" className="w-full border-y border-background-200 bg-background-100/70 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="font-label text-xs uppercase tracking-[0.22em] text-accent-700">
              Verify in order
            </span>
            <h3 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              时间线核对：四步判断可信度
            </h3>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            把零散的实锤照片放回同一条时间线，来源、时间戳与定位三者能互相印证时，结论才站得住。
          </p>
        </div>

        <ol className="relative mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          <span className="absolute left-0 right-0 top-6 hidden h-px bg-background-300 lg:block" />
          {timelineSteps.map((step, index) => (
            <li key={step.id} className="relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
              <span
                className={`relative z-10 flex h-12 w-12 items-center justify-center rounded-full border-4 border-background-100 font-heading text-lg font-black ${
                  index % 2 === 0
                    ? "bg-primary-500 text-background-50"
                    : "bg-accent-500 text-accent-950"
                }`}
              >
                {index + 1}
              </span>
              <span className="mt-4 font-label text-xs uppercase tracking-[0.18em] text-foreground-400">
                {step.time}
              </span>
              <h4 className="mt-1 font-heading text-lg font-bold text-foreground-950">
                {step.title}
              </h4>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}